<template>
	<v-card>
		<app-section-loader :status="loader"></app-section-loader>
		<v-container grid-list-xs fluid>
			<v-layout row wrap>
				<v-flex xs12 md3>
					<v-card color="orange lighten-1" flat dark>
						<v-card-text class="text-center">
							<span class="white--text">Tổng số tiền chưa thu:</span>
							<div class="headline">{{calcTotalAmount(receipts) | formatNumber}} VND</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 md3>
					<v-card color="blue lighten-1" flat dark>
						<v-card-text class="text-center">
							<span class="white--text">Số phiếu cọc chưa thu:</span>
							<div class="headline">{{receipts.filter(r => r.type === "DEPOSIT").length}}</div>
							<!-- <small class="">({{calcTotalAmount(receipts.filter(r => r.type ==="DEPOSIT")) | formatNumber}} VND)</small> -->
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 md3>
					<v-card color="green lighten-1" flat dark>
						<v-card-text class="text-center">
							<span class="white--text">Số phiếu thu tiền phòng chưa thu:</span>
							<div class="headline">{{receipts.filter(r => r.type === "ROOM").length}}</div>
							<!-- <small class="">({{calcTotalAmount(receipts.filter(r => r.type ==="ROOM")) | formatNumber}} VND)</small> -->
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 md3>
					<v-card color="cyan" flat dark>
						<v-card-text class="text-center">
							<span class="white--text">Số phiếu chênh lệch:</span>
							<div class="headline">{{receipts.filter(r => r.type === "DIFFERENCE").length}}</div>
							<!-- <small class="">({{calcTotalAmount(receipts.filter(r => r.type ==="ROOM")) | formatNumber}} VND)</small> -->
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12>
					<v-layout row wrap>
						<v-flex xs12 md8>
							<div v-if="!loader" class="pa-2">
								<v-chip disabled color="green" text-color="white">Số phiếu đã chọn: {{selected.length}}</v-chip>
								<v-chip
									disabled
									color="blue"
									text-color="white"
								>Tổng số tiền: {{calcTotalAmount(selected) | formatNumber}} VND</v-chip>
							</div>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								v-model="search"
								prepend-icon="search"
								label="Tìm kiếm"
								hide-details
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2 class="text-center">
							<dialog-tao-phieu-co-gam
								:total_amount_selected="calcTotalAmount(selected)"
								:selected="selected"
								:loader="loader"
								@getReceiptData="getReceiptData"
							></dialog-tao-phieu-co-gam>
						</v-flex>
					</v-layout>
					<v-card>
						<v-data-table
							v-model="selected"
							:headers="headers"
							:items="receipts"
							:pagination.sync="pagination"
							:rows-per-page-items="rowPerPage"
							select-all
							item-key="_id"
							class="elevation-1"
							disable-initial-sort
							:search="search"
						>
							<template v-slot:headers="props">
								<tr>
									<th>
										<v-checkbox
											class="justify-center"
											:input-value="props.all"
											:indeterminate="props.indeterminate"
											primary
											hide-details
											@click.stop="toggleAll"
											:disabled="loader"
										></v-checkbox>
									</th>
									<th
										v-for="header in props.headers"
										:key="header.text"
										:class="[
											'column sortable', pagination.descending ? 'desc' : 'asc',
											header.value === pagination.sortBy ? 'active' : '',
											header.align ? `text-xs-${header.align}` : ''
										]"
										@click="changeSort(header.value)"
									>
										<v-icon small>arrow_upward</v-icon>
										<span style="padding-right: 16px">{{ header.text }}</span>
									</th>
								</tr>
							</template>
							<template v-slot:items="props">
								<tr :active="props.selected" @click="props.selected = !props.selected">
									<td>
										<v-checkbox
											class="justify-center"
											:disabled="loader"
											:input-value="props.selected"
											primary
											hide-details
										></v-checkbox>
									</td>
									<td class="text-xs-center">{{ props.index +1 }}</td>
									<td class="text-xs-left text-no-wrap">{{ props.item.title }}</td>
									<td class="text-xs-center">{{ props.item.receipt_id }}</td>
									<td class="text-xs-center">{{ props.item.receipt_date | formatTimeServer}}</td>
									<td class="text-xs-center">{{ props.item.room_id }}</td>
									<td class="text-xs-right">{{ props.item.receipt_amount | formatNumber }}</td>
									<td class="text-xs-center">{{ props.item.collector }}</td>
									<td class="text-xs-center text-no-wrap">{{ props.item.note }}</td>
								</tr>
							</template>
						</v-data-table>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</v-card>
</template>
<script>

import api from "../../api";
import { dayDiff, buildParamQuery } from "../../helpers/helpers";
import DialogTaoPhieuCoGam from "./DialogTaoPhieuCoGam";
import moment from 'moment'

export default {
	name: "tab-phieu-thu-chua-xu-ly",
	props: {
		current_tab: Number,
		chosen_month: String
	},
	components: {
		DialogTaoPhieuCoGam
	},
	data: () => ({
		loader: false,
		pagination: {},
		rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
		selected: [],
		headers: [
			{ text: "STT", value: "stt" },
			{ text: "Loại phiếu", value: "type", align: "left" },
			{ text: "Mã số phiếu", value: "receipt_id", align: "center" },
			{ text: "Ngày tạo", value: "receipt_date" },
			{ text: "Số phòng", value: "room_id" },
			{ text: "Số tiền", value: "receipt_amount", align: "right" },
			{ text: "Bảo vệ", value: "collector" },
			{ text: "Ghi chú", value: "note" }
		],
		receipts: [],
		receipt_text: {
			"ROOM": "Phiếu thu tiền phòng",
			"OTHER": "Phiếu thu khác",
			"DEPOSIT": "Phiếu cọc",
			"DIFFERENCE": "Chênh lệch của phiếu Chủ Trọ "
		},
		search: ""
	}),
	watch: {
		current_tab() {
			if (this.current_tab === 0) this.getReceiptData();
		}
	},
	created() {
		this.getReceiptData();
	},
	methods: {
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.receipts.slice();
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		async getReceiptData() {
			this.loader = true;
			this.receipts = [];

            const params = {
				isCollected: false,
				// dateStart: new Date(this.chosen_month + "-01").toISOString().substr(0, 10),
				// dateEnd: moment(this.chosen_month + "-01").endOf('month').toISOString().substr(0, 10),
				// month: this.chosen_month,
            }

			const query = buildParamQuery(params)
			const receipt_data = await Promise.all([
				api.getReceiptRoomAndOther(query),
				api.getDepositReceipts(query),
				api.getReceiptDifference(query)
			]);
			this.loader = false;
			receipt_data.forEach(receiptResult => {
				if (receiptResult.status == 200) {
					this.receipts = this.receipts.concat(
						receiptResult.data.map(receipt => {
							receipt.type = receipt.month
								? receipt.room_id ?  "ROOM" : "OTHER"
								: receipt.date_deposit
								? "DEPOSIT"
								: "DIFFERENCE";
							if (receipt.type === "ROOM" || receipt.type === "OTHER") {
								receipt.receipt_date = receipt.date_collected;
								receipt.receipt_amount =
									receipt.collected_amount;
									receipt.title = this.receipt_text[receipt.type]
							} else if (receipt.type === "DEPOSIT") {
								receipt.receipt_date = receipt.date_deposit;
								receipt.receipt_amount = receipt.deposit_amount;
								receipt.title = this.receipt_text[receipt.type]
							} else if (receipt.type === "DIFFERENCE"){
								receipt.receipt_date = receipt.date_collected;
								receipt.receipt_amount = receipt.collected_amount;
								receipt.title = this.receipt_text[receipt.type] + receipt.created_by_receipt_collected_id
							}
							return receipt;
						})
					);
				}
			});
			// this.receipts.map((rep, index) => {
			// 	rep.stt = index + 1;
			// 	return rep;
			// });
			this.receipts.sort((a, b) =>
				dayDiff(b.receipt_date, a.receipt_date)
			);
			// Get danh sách những phiếu chưa thu tiền (cọc, phòng)
			// Merge + sort theo ngày tạo phiếu
		},
		calcTotalAmount: arr =>
			arr.reduce(
				(accumulator, currentReceipt) => {
					if (currentReceipt.type === "DIFFERENCE") {
						return accumulator
					} else {
						return accumulator + currentReceipt.receipt_amount
					}
				},
				0
			)
	}
};
</script>
